import { render, staticRenderFns } from "./SpinnerLayerComponent.vue?vue&type=template&id=ea307be2&scoped=true&lang=pug"
import script from "./SpinnerLayerComponent.vue?vue&type=script&lang=ts"
export * from "./SpinnerLayerComponent.vue?vue&type=script&lang=ts"
import style0 from "./SpinnerLayerComponent.vue?vue&type=style&index=0&id=ea307be2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea307be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea307be2')) {
      api.createRecord('ea307be2', component.options)
    } else {
      api.reload('ea307be2', component.options)
    }
    module.hot.accept("./SpinnerLayerComponent.vue?vue&type=template&id=ea307be2&scoped=true&lang=pug", function () {
      api.rerender('ea307be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spinner/SpinnerLayerComponent.vue"
export default component.exports